import React from "react";
import {
    Box,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
    useMediaQuery
} from "@mui/material";
import "react-color-palette/lib/css/styles.css";
import {useTranslation} from "react-i18next";
import PersonalTags from "./PersonalTags";
import PersonIcon from '@mui/icons-material/Person';
import GroupsIcon from '@mui/icons-material/Groups';
import PublicTags from "./PublicTags";

export default function Annotation() {
    const {t} = useTranslation('common');
    const [step, setStep] = React.useState(0);
    const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'));

    const getActiveStep = () => {
        switch (step) {
            case 1:
                return <PublicTags title={t("main.pages.profile.annotation.menu.publicTag")}/>
            default:
                return <PersonalTags title={t("main.pages.profile.annotation.menu.myTag")}/>
        }
    }

    return (
        <Grid container>
            <Grid item xs={3} sm={3} md={3} lg={3}>
                <List>
                    <ListItem>
                        <ListItemText primary={<Typography fontWeight="bold">
                            {t("main.pages.profile.annotation.menu.title").toUpperCase()}
                        </Typography>}/>
                    </ListItem>
                    <Divider/>
                    <ListItemButton onClick={() => setStep(0)}>
                        {mdUp && <ListItemIcon>
                            <PersonIcon/>
                        </ListItemIcon>}
                        <ListItemText primary={<Typography fontWeight="bold" color="textSecondary">
                            {t("main.pages.profile.annotation.menu.myTag")}
                        </Typography>}/>
                    </ListItemButton>
                    <ListItemButton onClick={() => setStep(1)}>
                        {mdUp && <ListItemIcon>
                            <GroupsIcon/>
                        </ListItemIcon>}
                        <ListItemText primary={<Typography fontWeight="bold" color="textSecondary">
                            {t("main.pages.profile.annotation.menu.publicTag")}
                        </Typography>}/>
                    </ListItemButton>
                </List>
            </Grid>
            <Grid item xs={9} sm={9} md={9} lg={9} display="flex" flexDirection="column">
                <Box ml={1} flexGrow={1} display="flex" flexDirection="column">
                    {getActiveStep()}
                </Box>
            </Grid>
        </Grid>
    );
}